export default __webpack_public_path__ + "static/item_12-96b6a9b6f0bfeb1b69a93b0142b8ec97.jpg";